'use client'

import Script from 'next/script'

// NOTE: The badge is injected by gstatic as an iframe positioned via
// `position: 'BOTTOM_LEFT'`. We can't control its z-index from this repo
// (cross-origin iframe, no shadow DOM access). At narrow viewports it may
// overlap the chat button (z-40) or sit beside the cookie banner — see
// CC-6 in docs/responsive-audit.md. Visual stacking at the badge's own
// position is gstatic's responsibility.
export function GoogleMerchantBadge() {
  return (
    <>
      <Script 
        id="merchantWidgetScript" 
        src="https://www.gstatic.com/shopping/merchant/merchantwidget.js" 
        strategy="lazyOnload" 
        onLoad={() => {
          if (typeof window !== 'undefined' && (window as any).merchantwidget) {
            ;(window as any).merchantwidget.start({
              merchant_id: 5757667852,
              position: 'BOTTOM_LEFT', // Can be BOTTOM_LEFT or BOTTOM_RIGHT
            })
          }
        }}
      />
    </>
  )
}
